import type {ActionReducerMapBuilder} from "@reduxjs/toolkit";
import type {EventOneClickPromoReduxState} from "@Panels/event-one-click-promotion-panel/event-one-click-promotion-panel.types";

export const eventOneClickPromotionPanelExtraReducers = (builder: ActionReducerMapBuilder<EventOneClickPromoReduxState>) => {

}